import { useState, useCallback } from "react";
import { getGenericLogger } from "src/authentication-and-logging/authAndLogger";

const logger = getGenericLogger().createCategoryLogger("ErrorBoundary");

export function useErrorBoundary() {
	const [error, setError] = useState<any>(undefined);

	const handleError = useCallback((error: any, info?: any) => {
		setError(error);
		logger.debug("crash", { details: { error, info } });

		const sessionStorageKeys = Object.keys(sessionStorage);
		const sessionStorageValues: { [key: string]: string } = {};
		sessionStorageKeys.forEach((key) => {
			sessionStorageValues[key] = sessionStorage.getItem(key) ?? "";
		});

		const errorField = typeof error === "string" ? { error } : { errorObject: error };
		const infoField = typeof info === "string" ? { info } : { infoObject: info };

		logger.critical("crash", {
			details: { ...errorField, ...infoField, message: "Unhandled application error" },
		});
	}, []);

	return { error, handleError };
}
